module.exports = "/assets/ca7e891b9bf2eda275a1601f9adffac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/D9.png
// module id = 1293
// module chunks = 0